import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-windows2",
  "use": "icon-windows2-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-windows2\"><path d=\"M554.666667 554.666667h426.666666v426.666666H554.666667zM42.666667 554.666667h426.666666v426.666666H42.666667zM554.666667 42.666667h426.666666v426.666666H554.666667zM42.666667 42.666667h426.666666v426.666666H42.666667z\" fill=\"#98A3B7\" fill-opacity=\".8\" p-id=\"1754\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol